import { NgbDateParserFormatter, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { Injectable } from "@angular/core";

@Injectable()
export class NgbDateCustomFormatter extends NgbDateParserFormatter {
    readonly DELIMITER = "-";
    parse(value: string): NgbDateStruct | null {
        if (value) {
            const date = value.split(this.DELIMITER);
            if (date.length === 1 && Number(date[0])) {
                return { day: parseFloat(date[0]), month: null, year: null };
            } else if (date.length === 2 && Number(date[0]) && Number(date[1])) {
                return { day: parseFloat(date[0]), month: parseFloat(date[1]), year: null };
            } else if (date.length === 3 && Number(date[0]) && Number(date[1]) && Number(date[2])) {
                return { day: parseFloat(date[0]), month: parseFloat(date[1]), year: parseFloat(date[2]) };
            }
        }
        return null;
    }

    format(date: NgbDateStruct | null): string {

        return date
            ? `${Number(date.day) ? this.padNumber(date.day) : ""}-${Number(date.month) ? this.padNumber(date.month) : ""}-${date.year}`
            : "";
    }

    padNumber(value: number) {
        return Number(value) ? `0${value}`.slice(-2) : "";
    }
}
